import { Recipe, RecipeUUID } from '@library/menu-service'
import { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { useRecipe } from 'hooks/menu-recipes/useRecipe'

type RecipeDetails = {
  fiveADay?: Recipe['fiveADay']
  dietaryClaims?: Recipe['dietaryClaims']
  rating?: Recipe['rating']
  prepTime?: Recipe['prepTime']
  shelfLife: {
    minDays: number
    maxDays: number
  }
  kcalPerPortion?: number
  images: {
    partial?: Recipe['images']
    full?: MenuRecipe['images']
  }
  surcharge?: number
}

/**
 * Returns partial menu recipe data for certain properties whilst we fetch the full recipe by id
 */
export const useRecipeDetails = (
  uuid: RecipeUUID,
  fullRecipe: MenuRecipe | null,
): RecipeDetails => {
  const partialRecipe = useRecipe(uuid)

  return {
    fiveADay: partialRecipe?.fiveADay || fullRecipe?.five_a_day,
    dietaryClaims: partialRecipe?.dietaryClaims || fullRecipe?.dietary_claims,
    rating: partialRecipe?.rating || fullRecipe?.rating,
    prepTime: partialRecipe?.prepTime || fullRecipe?.prep_time,
    shelfLife: partialRecipe?.shelfLife || {
      minDays: fullRecipe?.shelf_life?.min_days || 0,
      maxDays: fullRecipe?.shelf_life?.max_days || 0,
    },
    kcalPerPortion:
      partialRecipe?.nutritionalInformation.perPortion.energyKcal ||
      fullRecipe?.nutritional_information.per_portion.energy_kcal,
    surcharge:
      partialRecipe?.surcharge?.pricePerPortion || fullRecipe?.surcharge?.price_per_portion,
    images: {
      partial: partialRecipe?.images,
      full: fullRecipe?.images,
    },
  }
}
